package com.flowyride.core.domain.navigation

import com.flowyride.core.domain.model.GeoPoint
import kotlinx.coroutines.flow.Flow

/**
 * One position from the GPS.
 *
 * @param bearing direction of travel (degrees, 0 = north); null when unknown (standing still).
 * @param speedMetersPerSecond null when unknown.
 * @param accuracyMeters radius of 68 % confidence; null when unknown.
 */
data class LocationFix(
    val point: GeoPoint,
    val timeMillis: Long,
    val bearing: Double? = null,
    val speedMetersPerSecond: Double? = null,
    val accuracyMeters: Double? = null,
)

/** Where positions come from: the device's GPS, or a simulation. */
interface LocationSource {
    /** Cold flow: collecting starts the updates, cancelling stops them. */
    fun fixes(): Flow<LocationFix>
}
